"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentDidCatch = exports.componentDidCatch = void 0;
const react_1 = __importDefault(require("react"));
const widgets_main_1 = require("../widgets-main");
const componentDidCatch = (key, widget, fallbackWidget) => (0, widgets_main_1.fromJSX)((setState) => (react_1.default.createElement(ComponentDidCatch, { setState: setState, fallbackWidget: fallbackWidget, child: widget.run(setState), key: key })));
exports.componentDidCatch = componentDidCatch;
class ComponentDidCatch extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ error: [error, errorInfo] });
    }
    render() {
        return this.state.error === undefined
            ? this.props.child
            : this.props.fallbackWidget(this.state.error).run(this.props.setState);
    }
}
exports.ComponentDidCatch = ComponentDidCatch;
